export default __webpack_public_path__ + "static/media/640_dummy2016-heilpraxis01-de.5c337882.png";